import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif;
  }
`

export default GlobalStyle;